module.exports = __webpack_public_path__ + "static/media/AerowalletWhiteBackground.6b0fc402.svg";